// client/src/services/userService.js
import api from './api';   // your existing axios instance with token interceptor

const userService = {
  /* ── Wishlist ─────────────────────────────────────────────────────── */

  /** Fetch all wishlisted trips for the logged-in user */
  getWishlist: async () => {
    const { data } = await api.get('/wishlist');
    return data; // { success, wishlist: Trip[] }
  },

  /** Add a trip by ID */
  addToWishlist: async (tripId) => {
    const { data } = await api.post(`/wishlist/${tripId}`);
    return data; // { success, wishlistIds: string[] }
  },

  /** Remove a trip by ID */
  removeFromWishlist: async (tripId) => {
    const { data } = await api.delete(`/wishlist/${tripId}`);
    return data; // { success, wishlistIds: string[] }
  },

  /** Clear entire wishlist */
  clearWishlist: async () => {
    const { data } = await api.delete('/wishlist/clear');
    return data;
  },
};

export default userService;
